import styled, { css } from 'styled-components';

// Headings Style
const HeadingLgStyle = css`
  /* font-family: 'Bryant Pro Medium'; */
  font-variant: tabular-nums;
  font-weight: normal;
  letter-spacing: normal;
  line-height: 1.2;
  margin: 0;
`;

// Headings Style
const HeadingMdStyle = css`
  /* font-family: 'Bryant Pro Medium'; */
  font-variant: tabular-nums;
  font-weight: normal;
  letter-spacing: 0.0175em;
  line-height: 1.2;
  margin: 0;
`;

// Text Style
const TextStyle = css`
  /* font-family: 'Bryant Pro Regular'; */
  font-variant: tabular-nums;
  font-weight: normal;
  letter-spacing: 0.0175em;
  line-height: 1.3;
  margin: 0;
`;

// Text Overflow Style
const TextOverflowStyle = css`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.overflow};
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: break-spaces;
`;

// Heading 1
const StyledH1 = styled.h1`
  ${HeadingLgStyle};
  font-size: ${(props) => props.theme.typography.heading1};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.blueMedium};
`;

// Heading 2
const StyledH2 = styled.h2`
  ${HeadingLgStyle};
  font-size: ${(props) => props.theme.typography.heading2};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.blueMedium};
`;

// Heading 3
const StyledH3 = styled.h3`
  ${HeadingLgStyle};
  font-size: ${(props) => props.theme.typography.heading3};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.blueMedium};
`;

// Heading 4
const StyledH4 = styled.h4`
  ${HeadingMdStyle};
  font-size: ${(props) => props.theme.typography.heading4};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Heading 5
const StyledH5 = styled.h5`
  ${HeadingMdStyle};
  font-size: ${(props) => props.theme.typography.heading5};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Heading 6
const StyledH6 = styled.h6`
  ${HeadingMdStyle};
  font-size: ${(props) => props.theme?.typography?.heading6 || '15.5px'};
  color: ${(props) => props.color !== undefined ? props.theme?.colors[props.color] : props.theme?.colors?.greyDark || '#63666A'};
`;

// SubHeading
const StyledSubHeading = styled.p`
  ${TextStyle};
  ${(props) => props.overflow && TextOverflowStyle}
  /* font-family: 'Bryant Pro Medium' !important; */
  font-size: ${(props) => props.theme.typography.subHeading};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Body Text
const StyledText = styled.p`
  ${TextStyle};
  ${(props) => props.overflow && TextOverflowStyle}
  font-size: ${(props) => props.theme.typography.bodyText};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Link Text
const StyledTextLink = styled.a`
  ${TextStyle};
  font-size: ${(props) => props.theme.typography.bodyText};
  color: ${(props) => props.theme.colors.blueDark};
  text-decoration: none;
  transition: .5s all;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

// Span Text
const StyledSpan = styled.span`
  ${TextStyle};
  ${(props) => props.overflow && TextOverflowStyle}
  font-size: ${(props) => props.theme.typography.bodyText};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Medium Text
const StyledMedium = styled.span`
  ${TextStyle};
  ${(props) => props.overflow && TextOverflowStyle}
  /* font-family: 'Bryant Pro Medium' !important; */
  font-size: ${(props) => props.theme.typography.bodyText};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Small Text
const StyledSmall = styled.small`
  ${TextStyle};
  ${(props) => props.overflow && TextOverflowStyle}
  font-size: ${(props) => props.theme.typography.smallText};
  color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyDark};
`;

// Bold Text
const StyledStrong = styled.strong`
  /* font-family: 'Bryant Pro Bold'; */
  font-variant: tabular-nums;
  font-weight: normal;
  font-size: inherit;
  letter-spacing: 0.0175em;
`;

// Highlighted Text
const StyledHighlight = styled.mark`
  font-variant: tabular-nums;
  font-size: inherit;
  background-color: hsl(209.6,100%,85%);
  letter-spacing: 0.0175em;
`;

// Italicized Text
const StyledItalic = styled.em`
  font-variant: tabular-nums;
  font-style: italic;
  font-size: inherit;
  letter-spacing: 0.0175em;
`;

// Underlined Text
const StyledUnderline = styled.u`
  font-variant: tabular-nums;
  font-size: inherit;
  text-decoration: underline;
  letter-spacing: 0.0175em;
`;

export const Typography = {
  H1: StyledH1,
  H2: StyledH2,
  H3: StyledH3,
  H4: StyledH4,
  H5: StyledH5,
  H6: StyledH6,
  SubHeading: StyledSubHeading,
  Text: StyledText,
  TextLink: StyledTextLink,
  Span: StyledSpan,
  Small: StyledSmall,
  Strong: StyledStrong,
  Medium: StyledMedium,
  Highlight: StyledHighlight,
  Italic: StyledItalic,
  Underline: StyledUnderline
};
